const actionScope = '[First Time Onboarding]';

export class MarkOnboardingAsCompleted {
  static readonly type = `${actionScope} Mark Onboarding As Completed`;
}

export class OnboardingCompleted {
  static readonly type = `${actionScope} Onboarding Completed`;
}
